import { useMemo } from "react";

// Accepts either a single { quote, author } via props, or a `quotes` array
// from which one is randomly chosen on each page load.
export default function PullQuote({ quote, author, quotes }) {
  const chosen = useMemo(() => {
    if (Array.isArray(quotes) && quotes.length > 0) {
      return quotes[Math.floor(Math.random() * quotes.length)];
    }
    return { quote, author };
  }, [quotes, quote, author]);

  return (
    <blockquote
      data-testid="pull-quote"
      className="relative my-12 mx-auto max-w-3xl px-8 py-8 border-l-4 border-rgv-red bg-gradient-to-r from-[#280000]/60 to-transparent"
    >
      <p className="font-display italic text-2xl sm:text-3xl text-white leading-snug">
        &ldquo;{chosen.quote}&rdquo;
      </p>
      <cite className="block mt-4 text-rgv-red not-italic font-semibold tracking-wide">
        — {chosen.author}
      </cite>
    </blockquote>
  );
}
